"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewRadio = exports.NewRadioGroup = void 0;
var radio_group_1 = require("./radio-group");
Object.defineProperty(exports, "NewRadioGroup", { enumerable: true, get: function () { return radio_group_1.NewRadioGroup; } });
Object.defineProperty(exports, "NewRadio", { enumerable: true, get: function () { return radio_group_1.NewRadio; } });
